// localStorage that never throws (private windows, blocked site data) and falls back to a default.

export function loadSetting(key, fallback) {
  try {
    const raw = window.localStorage.getItem(`bcv-${key}`);
    return raw === null ? fallback : JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

export function saveSetting(key, value) {
  try {
    window.localStorage.setItem(`bcv-${key}`, JSON.stringify(value));
  } catch (e) {
    // Settings are a convenience; the page works without them.
  }
}
